import React, { useEffect, useState, useRef, useCallback } from "react";
import CommonDialog from "../../common/dialog";
import i18next from "i18next";
import { makeStyles } from "@material-ui/core/styles";
import { message } from "../../common/alert";
import { addContact } from "../../../api/contactsChat/getContacts";
import JoinGroup from "../chatGroup/joinGroup/index";
import { rootStore } from "agora-chat-uikit";
import search_icon from '../../../assets/search.png';
import UserIcon from '../../../assets/user.svg';
import { Box, Button, InputBase, Typography, CircularProgress } from "@material-ui/core";
import { BACKEND_URL } from "../../../utils/constant";
const useStyles = makeStyles((theme) => {
  return {
    root: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      paddingBottom: theme.spacing(4),
      padding: "16px 24px",
      width: theme.spacing(60),
      boxSizing: "border-box"
    },

    searchBox: {
      height: '36px',
      width: '100%',
      marginBottom: '20px',
      display: 'flex',
      alignItems: 'center',
      borderRadius: '23px',
      background: '#F4F5F7'
    },
    searchImg: {
      width: '18px',
      height: '18px',
      paddingLeft: '8px'
    },
    buttonBox: {
      width: "100%",
      cursor: "pointer",
      display: "inline-flex",
      alignItems: "center",
      justifyContent: "flex-start",
      maxWidth: "none"
    },
    menus: {
      color: "#000000",
      fontSize: "14px",
      fontWeight: "500",
      typeface: "Ping Fang SC",
      textTransform: " none",
      maxWidth: "100%",
      display: "inherit",
      justifyContent: "flex-start"
    },
    inputLabel: {
      marginBottom: theme.spacing(4),
      width: "100%"
    },
    button: {
      width: "50%",
      marginTop: theme.spacing(11),
      color: "#fff"
    }
  };
});

export default function AddfriendDialog({ open, onClose }) {
  const classes = useStyles();
  // const dispatch = useDispatch()
  const [inputValue, setInputValue] = useState("");
  const [error, setError] = useState(null);
  const [usersList, setUsersList] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const currentUser = rootStore.client.context.userId;
  const addFriend = (inputValue) => {
    if (!inputValue) {
      return setError(true);
    }
    if (inputValue == currentUser) {
      return message.error(i18next.t("Cannot add yourself as a friend"));
    }
    addContact(inputValue, "hi");
    message.success(i18next.t("Successfully send the application"));
    setInputValue("");
    setError(null);
    onClose();
  };
  const handleChange = (event) => {
    setInputValue(event.target.value);
    setError(null);
  };
  const handleClose = () => {
    setInputValue("");
    setError(null);
    onClose();
  };

  const fetchUsersList = async (search) => {
    setIsLoading(true);
    try {
      const token = localStorage.getItem("token")
      const config = {
          headers: {
              'Content-Type': 'application/json',
          }
      }
      if (token) {
          config.headers.Authorization = `Bearer ${token}`;
      }
      config.headers["accept-language"] = "en";

      let res = await fetch(`${BACKEND_URL}users/list?search=${search}`, config)
      res = await res.json()
      console.log(res)
      setUsersList(res.data)
      // const data = res.data;
      // setUsersList(data);
    } catch (error) {
      console.error('Error fetching users:', error);
      setUsersList([]);
    } finally {
      setIsLoading(false);
    }
  }

  useEffect(() => {
    fetchUsersList("")
  }, [])



  // Alternative approach using useCallback for debouncing
  const debouncedFetchUsers = useCallback(
    (() => {
      let timeoutId;
      return (searchValue) => {
        clearTimeout(timeoutId);
        timeoutId = setTimeout(() => {
          fetchUsersList(searchValue);
        }, 500);
      };
    })(),
    []
  );

  const handleInputValue = (event) => {
    setInputValue(event.target.value);
    debouncedFetchUsers(event.target.value);
  }

  function renderContent() {
    return (
      <div style={{ width: "500px", padding: "32px" }}>
        <Box>
          <Box className={classes.searchBox}>
            <img src={search_icon} alt="" className={classes.searchImg} />
            <InputBase value={inputValue} placeholder={"login-UserID"} className={classes.inputSearch} onChange={handleInputValue} />
          </Box>
        </Box>

        <div className="add_friend_list_wrapper">
          {isLoading ? (
            <div style={{ 
              display: 'flex', 
              justifyContent: 'center', 
              alignItems: 'center', 
              padding: '20px',
              flexDirection: 'column'
            }}>
              <CircularProgress size={40} />
              <Typography style={{ marginTop: '10px', color: '#666' }}>
                Loading users...
              </Typography>
            </div>
          ) : (
            <ul>
              {
                usersList?.length > 0 && usersList?.map((user) => (
                  <li key={user?.id}>
                    <img src={UserIcon} alt="" className={classes.searchImg} />
                    <p>{user?.firstname} {user?.lastname} ({user?.username})</p>
                    <Button onClick={() => addFriend(user?.username)} className={classes.buttonBox}>
                      <Typography className={classes.menus}>
                       Send Request
                      </Typography>
                    </Button>
                  </li>
                ))
              }
              {!isLoading && usersList?.length === 0 && inputValue && (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '20px', 
                  color: '#666' 
                }}>
                  <Typography>No users found</Typography>
                </div>
              )}
              {!isLoading && usersList?.length === 0 && !inputValue && (
                <div style={{ 
                  textAlign: 'center', 
                  padding: '20px', 
                  color: '#666' 
                }}>
                  <Typography>Start typing to search for users</Typography>
                </div>
              )}
            </ul>
          )}
        </div>
      </div>
    );

    // return (
    //   // <Box className={classes.root}>
    //   //     <Typography className={classes.inputLabel}>
    //   //         {i18next.t('login-UserID')}
    //   //     </Typography>

    //   //     <TextField
    //   //         label={i18next.t('login-UserID')} variant="outlined" fullWidth autoFocus name="email"
    //   //         error={error}
    //   //         value={inputValue}
    //   //         onChange={handleChange} />

    //   //     <Button
    //   //         onClick={addFriend} variant="contained" color="primary" className={classes.button}>
    //   //         {i18next.t('Send')}
    //   //     </Button>
    //   // </Box>
    //   <div style={{ width: "500px", height: "400px", padding: "10px" }}>
    //     <JoinGroup
    //       contentObj={{
    //         placeholder: i18next.t("login-UserID"),
    //         title: "AgoraID"
    //       }}
    //       sendMethod={addFriend}
    //     />
    //   </div>
    // );
  }

  return (
    <CommonDialog
      open={open}
      onClose={handleClose}
      title={i18next.t("Send Contact Adding Request")}
      content={renderContent()}
    ></CommonDialog>
  );
}
